"use strict";
/**
 * Copyright 2022 Google LLC.
 * Copyright (c) Microsoft Corporation.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowsingContextStorage = void 0;
const protocol_js_1 = require("../../../protocol/protocol.js");
class BrowsingContextStorage {
    #contexts = new Map();
    getTopLevelContexts() {
        return Array.from(this.#contexts.values()).filter((c) => c.parentId === null);
    }
    removeContext(contextId) {
        this.#contexts.delete(contextId);
    }
    addContext(context) {
        this.#contexts.set(context.contextId, context);
        if (context.parentId !== null) {
            this.getKnownContext(context.parentId).addChild(context);
        }
    }
    hasKnownContext(contextId) {
        return this.#contexts.has(contextId);
    }
    findContext(contextId) {
        return this.#contexts.get(contextId);
    }
    getKnownContext(contextId) {
        const result = this.findContext(contextId);
        if (result === undefined) {
            throw new protocol_js_1.Message.NoSuchFrameException(`Context ${contextId} not found`);
        }
        return result;
    }
}
exports.BrowsingContextStorage = BrowsingContextStorage;
//# sourceMappingURL=browsingContextStorage.js.map